import { useState } from "react";
import { api } from "@/lib/api";
import { MessageSquare, Send, Loader2, Check, X } from "lucide-react";

export default function FeedbackModal({ onClose, userEmail }) {
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState(userEmail || "");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (message.trim().length < 3) {
      setError("A mensagem deve ter pelo menos 3 caracteres.");
      return;
    }
    setSending(true);
    setError("");
    try {
      await api.submitFeedback(message.trim(), email || null);
      setSent(true);
    } catch (err) {
      setError("Erro ao enviar. Tenta novamente.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center bg-black/70 backdrop-blur-sm">
      <div
        className="w-full max-w-md mx-4 bg-surface border border-line rounded-sm p-6 animate-slide-up"
        data-testid="feedback-modal"
      >
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <MessageSquare className="w-5 h-5 text-volt" />
            <h3 className="font-heading text-lg font-black uppercase tracking-tight">Sugestoes</h3>
          </div>
          <button
            data-testid="feedback-close-btn"
            onClick={onClose}
            className="p-1.5 hover:bg-surface-hover rounded-sm transition-colors"
          >
            <X className="w-4 h-4 text-txt-secondary" />
          </button>
        </div>

        {sent ? (
          <div className="text-center py-6">
            <Check className="w-12 h-12 text-volt mx-auto mb-3" />
            <p className="text-lg font-bold text-white mb-1">Obrigado!</p>
            <p className="text-sm text-txt-secondary">A tua sugestao foi enviada com sucesso.</p>
            <button
              onClick={onClose}
              className="mt-4 px-6 py-2 bg-volt text-volt-fg font-bold uppercase text-sm rounded-sm"
            >
              Fechar
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <p className="text-xs text-txt-secondary">
              Envia sugestoes de melhoria, novas ligas ou reporta erros. A tua opiniao ajuda-nos a melhorar!
            </p>

            {!userEmail && (
              <input
                data-testid="feedback-email-input"
                type="email"
                placeholder="Email (opcional)"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-obsidian border border-line rounded-sm px-4 py-2.5 text-sm text-white placeholder:text-txt-secondary/50 focus:border-volt focus:outline-none"
              />
            )}

            <textarea
              data-testid="feedback-message-input"
              placeholder="Escreve a tua sugestao aqui..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              rows={4}
              maxLength={1000}
              className="w-full bg-obsidian border border-line rounded-sm px-4 py-2.5 text-sm text-white placeholder:text-txt-secondary/50 focus:border-volt focus:outline-none resize-none"
            />

            <div className="flex justify-between items-center">
              <span className="text-[10px] text-txt-secondary">{message.length}/1000</span>
              {error && <span className="text-xs text-danger">{error}</span>}
            </div>

            <button
              data-testid="feedback-submit-btn"
              type="submit"
              disabled={sending || message.trim().length < 3}
              className="w-full bg-volt text-volt-fg font-bold uppercase tracking-wide px-6 py-2.5 rounded-sm transition-all hover:bg-volt-hover active:scale-[0.98] flex items-center justify-center gap-2 disabled:opacity-50"
            >
              {sending ? (
                <Loader2 className="w-4 h-4 animate-spin" />
              ) : (
                <>
                  <Send className="w-4 h-4" />
                  Enviar Sugestao
                </>
              )}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
